export enum ProductName {
  SSLI = "Super Simple Life Insurance",
  CLI = "Booster SmartCover Life and Terminal Illness",
  TPD = "Booster SmartCover Total and Permanent Disability",
  TCI = "Booster SmartCover Trauma and Critical Illness",
}
